export function formatCpf(cpf: string): string {
  // Se já estiver com pontos e traço, retorna como está
  if (cpf.includes('.') && cpf.includes('-')) return cpf;

  // Remove tudo que não for número
  const digits = cpf.replace(/\D/g, '');

  if (digits.length !== 11) return cpf;

  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}
